































import { defineComponent } from '@nuxtjs/composition-api';

import { useStaffById } from '@/composables/staff-by-id';

export default defineComponent({
  name: 'Workers',
  props: {
    categoryId: {
      type: String,
      default: '',
    },
    listType: {
      type: String,
      default: '',
    },
  },
  setup: (props) => {
    return ({
      ...useStaffById({ categoryId: Number(props.categoryId) }),
    });
  },
});
